<template>
  <NuxtLink v-if="link" :class="['app-markdown-tag', 'app-markdown-tag-link', formatClassName]" :to="link">
    <slot />
    <span :class="['app-markdown-tip']">
      {{ hoverText }}
    </span>
  </NuxtLink>
  <span
    v-else
    v-clickout="hideHoverText"
    :class="['app-markdown-tag', formatClassName, showTip && 'active']"
    :title="hoverText"
    @click="toggleHoverText"
  >
    <slot />
    <span :class="['app-markdown-tip', showTip && 'show']">
      {{ hoverText }}
    </span>
  </span>
</template>
<script lang="ts" setup>
import { Device } from '~/utils'

const props = defineProps({
  link: String,
  name: String,
  hoverText: String,
  className: String
})
const showTip = ref(false)
let timer: any
const formatClassName = computed(() => {
  return props.className?.replace(/_/g, '-')
})
const toggleHoverText = () => {
  if (!Device().isMobile) return
  showTip.value = !showTip.value
}
const hideHoverText = () => {
  showTip.value = false
}
watch(
  () => showTip.value,
  (value) => {
    if (value) {
      timer = setTimeout(() => {
        showTip.value = false
        clearTimeout(timer)
      }, 3000)
    } else {
      clearTimeout(timer)
    }
  }
)
</script>
<style lang="scss" scoped>
.app-markdown-tag {
  position: relative;
  font-size: 12px;
  line-height: 14px;
  padding: 4px 10px;
  color: #c8ccd3;
  transition: 0.3s;
  cursor: default;
  text-decoration: none;
  &.active {
    color: #fff;
  }
  &.app-markdown-tag-link {
    cursor: pointer;
  }
  &.module-tag,
  &.target-tag,
  &.cl-or-fe-tag,
  &.common-tag {
    &.app-markdown-tag-link {
      background-color: #363a41;
    }
    background-color: #18191a;
  }
  &.obsolete-tag {
    cursor: not-allowed;
    background-color: #626262;
  }
  &.ownertypes-tag {
    background-color: #3c4f6c;
  }
  &.enum-type-tag,
  &.component-type-tag,
  &.module-type-tag {
    background-color: #2a575a;
  }
  &.component-addable-tag {
    background-color: #284031;
  }
  &.component-combine-tag {
    background-color: #5e415b;
  }
  &.component-exclusive-tag,
  &.module-exclusive-tag {
    background-color: #603d3d;
  }
  &.module-rely-tag {
    background-color: #463561;
  }
}
.app-markdown-tip {
  display: none;
}
.app-markdown-tip {
  position: absolute;
  top: 120%;
  left: 10%;
  z-index: 1;
  color: #000;
  min-width: 100px;
  max-width: 160px;
  text-align: center;
  background-color: #d2d2d2;
  font-size: 12px;
  padding: 2px 6px;
  line-height: normal;
  &.show {
    display: inline-block;
  }
}
@media not all and (hover: none) {
  .app-markdown-tag {
    &:hover {
      color: #fff;
      .app-markdown-tip {
        display: inline-block;
      }
      &.obsolete-tag {
        color: #c8ccd3;
      }
      &.module-tag,
      &.common-tag {
        &.app-markdown-tag-link {
          background-color: #586376;
        }
      }
    }
  }
}

@media not all and (min-width: 1024px) {
  .app-markdown-tag {
    font-size: 18px;
    line-height: 22px;
    padding: 6px 15px;
  }
  .app-markdown-tip {
    min-width: 200px;
    max-width: 280px;
    background-color: #d2d2d2;
    font-size: 20px;
    padding: 6px 8px;
    line-height: normal;
    &.show {
      display: inline-block;
    }
  }
}
</style>
